import { FunctionComponent } from "react";

import {
  BusinessRolesSelect,
  BusinessRolesSelectProps
} from "../../pickers/BusinessRolesSelect";
import { useFieldContext, useFieldRegister } from "@bps/fluent-ui";

type ExpBusinessRolesSelectFieldProps = Omit<
  BusinessRolesSelectProps,
  "selectedKeys" | "onChangeSelectedKeys"
> & { name: string };

export const ExpBusinessRolesSelectField: FunctionComponent<ExpBusinessRolesSelectFieldProps> = ({
  name,
  ...restBusinessSelectProps
}) => {
  useFieldRegister(name);
  const { value, setFieldValue, disabledForm } = useFieldContext<
    string | string[] | undefined
  >(name);

  return (
    <BusinessRolesSelect
      selectedKeys={value}
      onChangeSelectedKeys={setFieldValue}
      {...restBusinessSelectProps}
      disabled={restBusinessSelectProps.disabled || disabledForm}
    />
  );
};
